const userArrange = {
  getArrangement() {
    return '/api/backstageApply/getPersonalItinerary'
  },
  getVipTrip() {
    return '/api/wzVipJourney/getVipJourney'
  }
}

export default userArrange